import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import 'elmo-elements/dist/main.css';
import store from './app/store';
import App from './App';
import FlashMessage from '@/lib/flashMessage';
import { init as initApm } from '@elastic/apm-rum';
import getConfig from '@/lib/config/index';
import { ErrorBoundary } from 'react-error-boundary';
import { Fallback } from '@/lib/Error/fallback';
import { errorHandler } from '@/lib/Error';
import { worker } from '@/mocks/browser';
import { LDContextProvider } from '@/components/Providers';

if (getConfig.isAPMEnabled) {
  initApm({
    serviceName: getConfig.serviceName,
    serverUrl: getConfig.serverUrl,
  });
}

// Only start MSW if explicitly enabled via REACT_APP_ENABLE_MOCKS=true
// For local dev with real backend, keep this disabled
if (
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_ENABLE_MOCKS === 'true'
) {
  worker.start({
    onUnhandledRequest: 'bypass',
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('ElmoSandcastleRoot')!,
);

root.render(
  <Provider store={store}>
    <LDContextProvider>
      <ErrorBoundary FallbackComponent={Fallback} onError={errorHandler}>
        <App />
        <FlashMessage />
      </ErrorBoundary>
    </LDContextProvider>
  </Provider>,
);
